import React from 'react';
import { RATING_TYPES_NAMES } from '@/finsight/ui/components/deals/DealListTable/components/DealBody/Tranches/Sector/SectorColumns';
import ClassCell from '../Cells/ClassCell';
import CurrencyCell from '../Cells/CurrencyCell';
import SizeCell from '../Cells/SizeCell';
import WalCell from '../Cells/WalCell';
import WalxCell from '../Cells/WalxCell';
import RatingAgencyCell from '../Cells/RatingAgencyCell';
import CreditEnhancementCell from '../Cells/CreditEnhancementCell';
import LoanToValueCell from '../Cells/LoanToValueCell';
import CouponTypeCell from '../Cells/CouponTypeCell';
import BenchmarkCell from '../Cells/BenchmarkCell';
import GuidanceCell from '../Cells/GuidanceCell';
import SpreadCell from '../Cells/SpreadCell';
import CouponCell from '../Cells/CouponCell';
import YieldCell from '../Cells/YieldCell';
import PriceCell from '../Cells/PriceCell';
import GuidanceIPTCell
  from '@/finsight/ui/components/deals/DealListTable/components/DealBody/Tranches/Cells/GuidanceIPTCell';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

interface IProps {
  tranche: any,
  isDealCmbs: boolean,
  ratingsMapping: any[],
  dealProductId: string,
  rowIndex: number,
}

const TableRow = ({ tranche, isDealCmbs, dealProductId, ratingsMapping, rowIndex }: IProps) => (
  <tr>
    <ClassCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <CurrencyCell
      className={ alignStyles.alignCenter }
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <SizeCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <WalCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    {
      isDealCmbs && (
        <WalxCell
          rowIndex={ rowIndex }
          tranche={ tranche }
        />
      )
    }
    { ratingsMapping
      .filter((rating) => rating.displayName !== RATING_TYPES_NAMES.MS)
      .map((rating, index) => (
        <RatingAgencyCell
        /* eslint-disable-next-line react/no-array-index-key */
          key={ index }
          rating={ rating }
          tranche={ tranche }
          rowIndex={ rowIndex }
        />
    )) }
    <CreditEnhancementCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <LoanToValueCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <CouponTypeCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <BenchmarkCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <GuidanceIPTCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <GuidanceCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <SpreadCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <CouponCell
      rowIndex={ rowIndex }
      tranche={ tranche }
      dealProductId={ dealProductId }
    />
    <YieldCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <PriceCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
  </tr>
);

export default TableRow;
